import Reflux from "reflux";

export default Reflux.createActions([
  "hideBanner",
  "optAuthorIntoQA",
]);
